import styled from 'styled-components'

export const StyledCenteredDiv = styled.div`
    display: flex;
    justify-content: center;
`